/**
 * Les rares icônes de l'application, en SVG.
 *
 * POURQUOI PAS DES CARACTÈRES
 *
 * Inter ne contient ni ✓ (U+2713), ni ✕ (U+2715), ni ＋ (U+FF0B), ni ⚙
 * (U+2699). Le navigateur cherche alors une police de repli — et sur iOS il
 * n'en trouve pas toujours, ce qui rend un carré vide. Le piège est sournois
 * parce que ces glyphes s'affichent parfaitement dans un éditeur de code et
 * sur un poste de développement : il n'apparaît que sur l'appareil réel.
 *
 * Il m'est tombé dessus trois fois de suite — sur le ＋ de la barre
 * d'onglets, sur le ＋ de l'ajout rapide, puis sur le ✓ du scanner. D'où ce
 * fichier : un seul endroit, et plus aucune tentation d'écrire un caractère.
 */

type Props = { className?: string; strokeWidth?: number }

function Svg({
  children,
  className = 'size-5',
  strokeWidth = 2,
}: Props & { children: React.ReactNode }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  )
}

export const Croix = (p: Props) => (
  <Svg {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Svg>
)

export const Coche = (p: Props) => (
  <Svg {...p}>
    <path d="M20 6 9 17l-5-5" />
  </Svg>
)

export const Plus = (p: Props) => (
  <Svg {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
)

export const Reglage = (p: Props) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
  </Svg>
)

export const Chevron = (p: Props) => (
  <Svg {...p}>
    <path d="m9 18 6-6-6-6" />
  </Svg>
)
